import * as DMConst from "./DMConst";

export function getVMMC_TargCov1DFltArray(VMMC_Cov2DFltArray) {
    /* The server expects 2 slots in front of the 11 coverage slots corresponding to the age groups. */
    let VMMC_TargCov1DFltArray = [0.0, 0.0];

    if (VMMC_Cov2DFltArray.length === 0) {
        VMMC_TargCov1DFltArray = VMMC_TargCov1DFltArray.concat([0.0, 0.8, 0.8, 0.8, 0.8, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]);
    } else {
        let VMMC_Cov2DFltArrayClone = JSON.parse(JSON.stringify(VMMC_Cov2DFltArray));

        for (let a = 1; a <= DMConst.numVMMC_AgeGroups; a++) {
            VMMC_TargCov1DFltArray.push(VMMC_Cov2DFltArrayClone[a - 1][DMConst.targetCoverage - 1] / 100);
        }
    }

    return VMMC_TargCov1DFltArray;
}
